import { Outlet, Link, useLocation } from "react-router-dom"
import { useState } from "react";

const Header = () => {
    const [menuToggle , setMenu]=useState(false)

const changeMenu = () => {    
    setMenu(() => !menuToggle);
}




  return (
      <div className="header">
        <nav className="navbar">
            <Link to="/" className="navLogo">
                <img alt="MTS logo" src={"/images/branding/logoMTS.svg"}/>
            </Link>
                <ul id="menu" className={menuToggle ? "showMenu" : "hideMenu"}>
                    <li>
                        <a href="#project-section">Crypto</a>
                    </li>
                    <li>
                        <a href="#project-section">Education</a>
                    </li>
                    <li>
                        <a href="#project-section">Services</a>
                    </li>
                    <li>
                        <a href="#meet-our-projects">Projects</a>
                    </li>
                    <li>
                        <a href="#meet-our-team">Team</a>
                    </li>
                    <li>
                        <a href="#contact">Contact</a>
                    </li>
                </ul>
        </nav>
      </div>
    );
  };
  
export default Header;